!((document, Drupal, $) => {
  'use strict';

  /**
   * Handle the main navigation menu for mobile
   *
   * All elements shown in this menu are cloned from elements generated
   * for the desktop version of the website.
   */
  Drupal.behaviors.menuMainMobile = {

    attach: function (context) {

      /**
       * Recursive method allowing to retrieve all children of a specific
       * link
       *
       * @param {object} $parent Parent element
       * @param {int} level Menu level
       * @returns {string} HTML code
       */
      function getMainLinksChildrenHtml($parent, level) {
        let levelSelector = '.level' + level;

        let $childElements;
        if ($parent.hasClass('uk-nav-header')) {
          $childElements = $parent.siblings(levelSelector);
        }
        else {
          $childElements = $parent.find(levelSelector);
        }

        if (!$childElements.length) {
          return '';
        }

        let html = '';

        $childElements.each(function(i, childElement) {

          let $childElement = $(childElement);

          // Clone the element and clean it
          let $newElement = $childElement.clone();
          $newElement.find('a')
            .removeClass()
            .attr('uk-icon', null);

          $newElement.find('div').remove(); // remove sub contains if existing
          $newElement.find('svg').remove(); // remove SVG icon if existing

          // If the element contains a button, use only its contain
          $newElement.find('button').replaceWith(function() {
            return $(this).html();
          });

          // Get all children
          let childrenHtml = getMainLinksChildrenHtml($childElement, level + 1);
          const newElementLevel = 'js-level-' + level;
          if (childrenHtml) {
            html += '' +
            '<li class=\'' + newElementLevel + ' has-children\'>' +
              $newElement.html() +
              '<ul class=\'' + newElementLevel + '-children\'>' +
                childrenHtml +
              '</ul>' +
            '</li>';
          }
          else {
            html += '' +
            '<li class=\'' + newElementLevel + '\'>' +
              $newElement.html() +
            '</li>';
          }

        });

        return html;
      }

      /**
       * Retrieves main links
       *
       * @returns {string} HTML code
       */
      function getMainLinksHtml() {
        let container = $('.header-navbar .main-menu');
        return getMainLinksChildrenHtml(container, 0);
      }

      /**
       * Retrieves secondary links
       *
       * @returns {string} HTML code
       */
      function getSecondaryLinksHtml() {
        let html = '';

        // eslint-disable-next-line max-len
        html += '<div uk-grid class="uk-grid uk-grid-small uk-grid-match uk-child-width-1-2 uk-text-center">';

        // eslint-disable-next-line max-len
        let $sourceElements = $('.header .secondary-menu').find('ul > li a');
        $sourceElements.each(function (i, sourceElement) {

          // Add UIkit classes on each element to avoid "flicking" effect
          let classes = [];

          if ((i % 2) === 0) {
            classes.push('uk-first-column');
          }
          if (i > 1) {
            classes.push('uk-grid-margin');
          }

          // eslint-disable-next-line max-len
          html += classes.length ? '<div class="' + classes.join(' ') + '">' : '<div>';

          html += $(sourceElement).clone()
            .removeClass()
            .addClass('uk-flex uk-flex-middle uk-flex-center')
            .wrap('<div class="item-wrapper"></div>')
            .parent()
            .html();

          html += '</div>';

        });

        html += '</div>';

        return html;
      }

      /**
       * Retrieves language switch links
       *
       * @returns {string} HTML code
       */
      function getLanguageSwitcherHtml() {
        let html = '';
        html += '<div class="uk-navbar-item language-switcher--mobile uk-hidden@m" id="language-switcher-mobile-container">';
        html += '<ul class="uk-subnav">';

        // eslint-disable-next-line max-len
        let $sourceElements = $('.header-navbar .language-switcher').find('ul > li > a');
        if ($sourceElements.length) {
          $sourceElements.each(function (i, element) {
            html += $(element).clone()
              .wrap('<li/>')
              .wrap('<div class="item-wrapper"></div>')
              .parent()
              .html();
          });
        }

        html += '</ul></div>';
        html += '</div>';

        return html;
      }

      /**
       * Retrieves the shop box CTA
       *
       * @returns {string} HTML code
       */
      function getShopBoxCtaHtml() {
        let html = '';

        html += '<div class="block-shop-box">';
        let $blockShopBox = $('.header .block-shop-box');

        // eslint-disable-next-line max-len
        let $sourceElement = $blockShopBox.find('a.shop-box-cta');
        if ($sourceElement.length) {
          let $newElement = $sourceElement.clone();
          // Because of user account box
          $newElement.addClass('uk-margin-medium-right');

          html += $newElement
            .wrap('<div class="item-wrapper"></div>')
            .parent()
            .html();
        }
        // User account box
        // eslint-disable-next-line max-len
        let $userAccountSource = $blockShopBox.find('.js-webshop-user-account-info');
        if ($userAccountSource.length) {
          let $newAccountElement = $userAccountSource.clone(true, true);
          // eslint-disable-next-line max-len
          $newAccountElement.removeClass('toggler').addClass($newAccountElement.data('mobileToggler'));
          let $ukDropdown = $newAccountElement.find('.uk-dropdown');
          // eslint-disable-next-line max-len
          $ukDropdown.attr('uk-dropdown', $ukDropdown.data('ukDropdownMobile'));
          html += $newAccountElement
            .wrap('<div class="item-wrapper"></div>')
            .parent()
            .html();
        }

        html += '</div>';

        return html;
      }

      /**
       * Retrieves the search button
       *
       * @returns {string} HTML code
       */
      function getSearchFormHtml() {
        let html = '';

        html += '<div class="block-search">';

        // eslint-disable-next-line max-len
        let $sourceElement = $('.header .block-search').find('form');
        if ($sourceElement.length) {
          let $newElement = $sourceElement.clone();

          // Change field data to avoid id/name conflicts
          $newElement.find('.uk-form-label')
            .attr('for', 'mobile-edit-keywords');
          $newElement.find('.uk-search-input')
            .attr('data-drupal-selector', 'mobile-edit-keywords')
            .attr('id', 'mobile-edit-keywords');

          html += $newElement
            .wrap('<div class="item-wrapper"></div>')
            .parent()
            .html();
        }

        html += '</div>';

        return html;
      }

      // Add mobile language switcher
      // eslint-disable-next-line max-len
      const $headerLanguageSwitcherMobile = $(once('headerLanguageSwitcherMobile', '#webshop-mobile-container', context));
      $headerLanguageSwitcherMobile.each(function () {
        $(this).html(getShopBoxCtaHtml());
      });

      // eslint-disable-next-line max-len
      const $menuMainMobile = $(once('menuMainMobile', '#menu-main-mobile-container', context));
      $menuMainMobile.each(function () {

        // Set-up the HTML content
        // eslint-disable-next-line max-len
        let html = $('<nav id="menu-main-mobile" class="menu-main-mobile uk-hidden@m">' +
          '<ul id="panel-menu">' +
            getMainLinksHtml() +
          '</ul>' +
        '</nav>');

        $(this).append(html);

        // Initialize mmenu-js lib now that we have prepared the DOM correctly
        let $menu = $(this).find('#menu-main-mobile');
        $menu.mmenu({
          extensions 	: [
            'fx-listitems-slide',
            'border-none',
            'position-right',
            'position-front',
            'pagedim-black',
            'multiline'
          ],
          navbar: {
            title: ' ' // use a space to keep the title container visible
          },
          navbars: [
            {
              position: 'top',
              content: [
                getLanguageSwitcherHtml()
              ]
            },
            {
              position: 'top',
              content: [
                getSearchFormHtml(),
                'prev',
                'title',
                'close'
              ]
            },
            {
              position: 'bottom',
              content: getSecondaryLinksHtml()
            }
          ],
          backButton: {
            close: true
          },
          hooks: {
            'openPanel:start': (panel) => {
              let $menuContainer = $('#menu-main-mobile');

              // Replace close button icon and remove useless attribute
              $menuContainer.find('.mm-btn_close')
                .addClass('uk-icon')
                .attr('uk-icon', 'icon: close; ratio: 2;')
                .attr('aria-owns', null);

              // Add icon to all main items
              $menuContainer.find('.mm-listitem__btn')
                .addClass('uk-icon')
                .attr('uk-icon', 'icon: chevron-right; ratio: 1.4;');

              // Replace prev button icon
              $menuContainer.find('.mm-btn_prev')
                .addClass('uk-icon')
                .attr('uk-icon', 'icon: arrow-left; ratio: 1.6;');

              // Initial screen - Home
              if (panel.id === 'panel-menu') {
                $menuContainer.removeClass('mm-menu_child-panel');
                $menuContainer.find('.block-search').show();
                $menuContainer.find('.mm-navbar__title').hide();
              }
              else { // Child screens
                $menuContainer.addClass('mm-menu_child-panel');
                $menuContainer.find('.block-search').hide();
                $menuContainer.find('.mm-navbar__title').show();
              }

            },
            'openPanel:before': (panel) => {
              // eslint-disable-next-line max-len
              const level2Children = panel.querySelector('.js-level-1-children');
              if (!level2Children) {
                return;
              }
              // Remove the mm-panel class from the panel to prevent mmenu
              // from opening the panel
              panel.classList.remove('mm-panel');
            }
          }
        });

        // Listen to button mm-btn_next
        const $menuContainer = $('#menu-main-mobile');
        // on click on menuContainer, set focus on search form and
        // remove mm-wrapper-_opened class which blocks accessibility tabs navigation
        $('#menu-main-mobile-container').on('click', function() {
          $('body').removeClass('mm-wrapper_opened');
          let searchForm = $('#menu-main-mobile').find('.form-text').first();
          if (searchForm.length) {
            searchForm.focus();
          }
        });
        // eslint-disable-next-line max-len
        $menuContainer.find('.js-level-1.has-children').each(function(i, menuLevel) {
          let $menuLevel = $(menuLevel);
          const nextElementBtn = $menuLevel.find('a.mm-btn_next');
          const subId = nextElementBtn.attr('href').replace('#', '');
          const $ul = $(context).find('#' + subId).find('ul').clone();
          $ul.find('li').removeClass();
          // eslint-disable-next-line max-len
          const $childrenElement = '<div class="mm-listitem__children js-mm-listitem-children-' + subId + '">' + $ul.html() + '</div>';
          $menuLevel.after($childrenElement);

          // eslint-disable-next-line max-len
          let $childrenContainer =  $(context).find('.js-mm-listitem-children-' + subId);
          $childrenContainer.attr('aria-hidden', 'true');
          // Listen second level menu
          nextElementBtn.on('click', function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            // Menu parent
            $menuLevel.toggleClass('mm-listitem--opened');
            // Children container
            if ($menuLevel.hasClass('mm-listitem--opened')) {
              $childrenContainer.slideDown('fast');
              $childrenContainer.removeAttr('aria-hidden');
            }
            else {
              $childrenContainer.slideUp('fast');
              $childrenContainer.attr('aria-hidden', 'true');
            }
          });
        });
      });

    }
  };

})(document, Drupal, jQuery);
